import React from 'react';

import { Image } from '$partials/media';
import { useLocale } from '$contexts/locale.jsx';
import { VerifiedTick, ProBadge } from '$partials/icons/index.js';
import { resolvePath } from '$utilities/routes';
import { Button } from '$partials/ui';
const defaultImage = {
    src: '/images/default-x1.jpg',
    x2: '/images/default-x2.jpg',
};

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/listings.d.ts').ArticleListingItem}
 */

const ArticleListingItem = ({
    listingImage,
    listingText,
    pageTitle,
    avatar,
    cfMetadata,
    slug
}) => {
    const { formatURI } = useLocale();

    return (
        <div className='expand-interaction group'>
            <figure className='w-full relative rounded-button overflow-clip'>
                <Image
                    className='rounded-button overflow-clip'
                    {...(listingImage || defaultImage)} />
                <div className='absolute inset-0 bg-[#0000000D] opacity-0 group-hover:opacity-100 transition-opacity rounded-button' />
            </figure>
            {avatar && (
                avatar?.link ? (
                    <Button
                        as='a'
                        className='flex items-center gap-16 mt-24 group'
                        href={avatar.link}>
                        {avatar?.avatarImage && (
                            <div className='relative'>
                                <Image
                                    className='object-cover h-full w-full'
                                    containerClassName='rounded-full h-[56px] w-[56px] overflow-hidden relative'
                                    src={avatar?.avatarImage?.src}/>
                                <div
                                    className='absolute inset-0 h-[56px] w-[56px] rounded-full opacity-0 group-hover:opacity-100 transition-opacity'
                                    style={{ background: 'rgba(0, 0, 0, 0.15)' }} />
                                {avatar?.verified && (
                                    <div className='absolute top-0 -right-5'>
                                        <VerifiedTick />
                                    </div>
                                )}
                            </div>
                        )}
                        <div className='flex flex-col gap-y-3'>
                            <span className='type-style-body text-text-primary group-hover:text-brand-500 transition-colors'>
                                {avatar?.name}
                                {avatar?.pro && <ProBadge className='inline-block ml-8 w-24'/>}
                            </span>
                            <span className='type-style-body text-text-tertiary'>{avatar?.role}</span>
                        </div>
                    </Button>
                ) : (
                    (avatar?.avatarImage || avatar?.name || avatar?.role) &&

                        <div className='flex items-center gap-16 mt-24'>
                            {avatar?.avatarImage && (
                                <div className='relative'>
                                    <Image
                                        className='object-cover h-full w-full'
                                        containerClassName='rounded-full h-[56px] w-[56px] overflow-hidden relative'
                                        src={avatar?.avatarImage?.src}/>
                                    {avatar?.verified && (
                                        <div className='absolute top-0 -right-5'>
                                            <VerifiedTick />
                                        </div>
                                    )}
                                </div>
                            )}
                            <div className='flex flex-col gap-y-3'>
                                <span className='type-style-body text-text-primary'>
                                    {avatar?.name}
                                    {avatar?.pro && <ProBadge className='inline-block ml-8 w-24'/>}
                                </span>
                                <span className='type-style-body text-text-tertiary'>{avatar?.role}</span>
                            </div>
                        </div>
                )
            )}
            <div className='mt-24 flex flex-col'>
                <h4 className='type-style-5 text-text-primary'>
                    <a
                        className='w-full expand-interaction__action'
                        href={formatURI(resolvePath({ slug: slug, cfMetadata: cfMetadata }))}>
                        {pageTitle}
                    </a>
                </h4>
            </div>
            {listingText && (
                <div className='mt-18 md:mt-10 type-style-body text-text-tertiary'>
                    {listingText}
                </div>
            )}
        </div>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

export default ArticleListingItem;
